export default __webpack_public_path__ + "static/media/buy-sell.90b3dfdc.jpg";